import React, { Component } from 'react';

import { DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem } from 'reactstrap';


import "./Header.css";

import Logo from "./images/startbereitlogo.png";

import {
    Link,
    withRouter
} from 'react-router-dom';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = { currentUser: null, collapsed: true };
    }

    toggleNavbar = () => {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    hideNavbar = () => {
        this.setState({
            collapsed: true
        });
    }

    render() {
        const dropDown = (
            <UncontrolledDropdown nav inNavbar>
                <DropdownToggle nav caret>
                    <i className="fa fa-user-circle jh-logged-in-icon"></i> {this.state.currentUser}
                </DropdownToggle>
                <DropdownMenu right className="text-right jh-profile-dropdown">
                    <DropdownItem><Link className="dropdown-item" to="/meine-veranstaltungen">Meine Veranstaltungen <i className="fa fa-calendar"></i></Link></DropdownItem>
                    <DropdownItem><Link className="dropdown-item" to="/meine-organisation">Meine Organisation <i className="fa fa-building"></i></Link></DropdownItem>
                    <DropdownItem divider />
                    <DropdownItem><Link className="dropdown-item" to="/abmelden">Abmelden <i className="fa fa-sign-out"></i></Link></DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        );

        return (
            <div>
                <Navbar color="white" light expand="md">
                    <NavbarBrand href="/" style={{color: "#014c72"}} className="mr-auto"><img src={Logo} className="img-fluid rounded mx-auto d-block" alt="Logo des Turnvereins Weiler i.d.B." style={{ height: "40px"}}/></NavbarBrand>
                    <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                    <Collapse isOpen={!this.state.collapsed} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem className="my-2 my-md-0 mr-md-3">
                                <Link to="/" className="nav-link" onClick={this.hideNavbar}>Willkommen</Link>
                            </NavItem>
                            <NavItem className="my-2 my-md-0 mr-md-3">
                                <Link to="/veranstaltungen" className="nav-link" onClick={this.hideNavbar}>Veranstaltungen</Link>
                            </NavItem>
                            <NavItem className="my-2 my-md-0 mr-md-3">
                                <Link to="/impressum-datenschutz" className="nav-link" onClick={this.hideNavbar}>Datenschutz &amp; Impressum</Link>
                            </NavItem>

                            {this.state.currentUser != null && dropDown}
                        </Nav>
                    </Collapse>
                </Navbar>
            </div>
        );
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/Header.js